// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2088":"93adc9af020fd0e2","4881":"72ea9bf63001dba5","8324":"9d668f365857eced"}[chunkId] + ".css";
};